import { useState } from 'react';
import { Link } from 'react-router';
import { Brand, SessionUserMenu } from '../components/Header';
import { ProfileDialog } from '../components/dialogs/ProfileDialog';
import { Icon } from '../components/Icon';

/** Plain "You don't have access" page for Studio/Admin URLs typed without the rights (or inline inside an area). */
export function NoAccess({ area, inline }: { area: string; inline?: boolean }) {
  const [profile, setProfile] = useState(false);
  const body = (
    <div className="panel" style={{ maxWidth: 480, margin: '48px auto 0', textAlign: 'center' }}>
      <div className="notice" style={{ justifyContent: 'center' }}>
        <Icon name="lock" />
        <span>{area}</span>
      </div>
      <h3>You don’t have access</h3>
      <p className="help" style={{ margin: '0 0 14px' }}>
        Ask an admin if you think you should be able to use this.
      </p>
      <Link className="btn primary" to="/">
        Back to photos
      </Link>
    </div>
  );
  if (inline) return body;
  return (
    <>
      <header className="top">
        <div className="top-row studio-row solo">
          <div className="top-left">
            <Brand />
          </div>
          <div className="actions">
            <SessionUserMenu onProfile={() => setProfile(true)} />
          </div>
        </div>
        {profile && <ProfileDialog onClose={() => setProfile(false)} />}
      </header>
      <main className="wrap">{body}</main>
    </>
  );
}
